/**
 * 十六进制转rgb
 *
 * @param hex
 * @returns {{r: *, g: *, b: *}}
 */
export const hexToRgbJson = (hex: string) => {
    if (!/^#[0-9a-fA-F]{6}$/.test(hex)) {
        return { r: 0, g: 0, b: 0 };
    }
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    return { r, g, b };
};
